import React from 'react';
import {useSelector} from 'react-redux';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

import {styles} from './CoachRank.style';

interface CoachRankProps {
  item: {
    rank?: {
      description?: string;
    };
  };
}
export const CoachRank: React.FC<CoachRankProps> = ({item}) => {
  const description = get(item, 'rank.description', '');
  const featureFlag = useSelector(variablesFeatureFlag);

  const showCsbPlusInsightsFiltering = shouldReleaseFeature(
    get(featureFlag, 'ff_csb_plus_insights_filtering', ''),
  );
  return showCsbPlusInsightsFiltering ? (
    <>
      <Text allowFontScaling maxFontSizeMultiplier={2} style={styles.CSBText}>
        {description}
      </Text>
    </>
  ) : (
    <> {description} </>
  );
};

export default CoachRank;
